import { minutesToSeconds } from '@maxpreps/shared/functions/primitiveHelpers/dateTimeHelpers';
import {
  IProjectConfig,
  IProjectMetaData
} from '@maxpreps/shared/models/metaTypes';
import buildTeamAuthorizationObject from './utils/buildTeamAuthorizationObject';

// creating stash
const projectMetaData: IProjectMetaData = {
  hierarchy: ['team']
};

const projectConfig: IProjectConfig = {
  projectMetaData,
  packagedCacheConfig: {
    edgeConfig: {
      maxAge: minutesToSeconds(5)
    },
    clientConfig: {
      maxAge: minutesToSeconds(5)
    }
  },
  getContextDataPoints: pageProps =>
    // Reminder: pageProps can be empty
    // Note: Probably should fill out schoolName - it's explici on the school project but not here...
    ({
      ...(pageProps?.teamContext?.data || {})
    })
};

if (typeof window === 'undefined') {
  projectConfig.buildAuthorizationObject = buildTeamAuthorizationObject;
}

export default projectConfig;
